




import { Component, Prop, Vue } from 'vue-property-decorator';

// Third party
import SignaturePad from 'signature_pad';


@Component
export default class SignaturePadComponent extends Vue {


    private signaturePad!: any;
    private resizeTimeoutTime = 800;
    private minPadHeight = 200;


    private mounted() {
        this.initializeComponent();
    }


    private initializeComponent() {
        const element = this.resizeCanvas();

        this.signaturePad = new SignaturePad(element, {
            penColor: '#15638c',
        });

        window.addEventListener('orientationchange', this.orientantionChange );
        this.signaturePad.onEnd = () => { this.emitHasSignature(true); };
    }

    private orientantionChange() {
        setTimeout( () => {
            this.resizeCanvas();
        }, this.resizeTimeoutTime);
    }

    private resizeCanvas() {
        const element = (this.$refs.signaturePad as HTMLCanvasElement) ;
        if ( element ) {
            const parentElement = (element.parentElement as any);
            const parentWidth = parentElement.offsetWidth;
            let parentHeight = parentElement.offsetHeight;
            if ( parentHeight < this.minPadHeight ) {
                parentHeight = this.minPadHeight;
            }
            element.setAttribute('width', parentWidth);
            element.setAttribute('height', parentHeight);
        }
        return element;
    }

    private hasSignature() {
        return !this.signaturePad.isEmpty();
    }

    public clearPad() {
        if ( this.signaturePad ) {
            this.emitHasSignature(false);
            this.signaturePad.clear();
        }
    }

    public getSignature() {
        return this.signaturePad.toDataURL();
    }

    private emitHasSignature(value: boolean) {
        this.$emit('has-signature', value);
    }

}
